import { gql } from "@apollo/client";

export const GET_MAX_MONTO_AJUSTE_CP = gql`
    query maxMontoAjusteCP {
        maxMontoAjusteCP {
            valorEsperado
            success
        }
    }
`;